import { render } from "./SleepCurve.vue?vue&type=template&id=9b844298&scoped=true&ts=true"
import script from "./SleepCurve.vue?vue&type=script&lang=ts"
export * from "./SleepCurve.vue?vue&type=script&lang=ts"

import "./SleepCurve.vue?vue&type=style&index=0&id=9b844298&scoped=true&lang=less"

import exportComponent from "D:\\work\\project\\mobile-mpe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b844298"]])

export default __exports__